type Props = { className?: string };

/** Custom filled star — replaces the lucide Star for ratings. Uses currentColor. */
export function StarIcon({ className }: Props) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d="m497.697 242.93c12.975-12.641 17.554-31.194 11.954-48.41-5.59-17.223-20.199-29.54-38.126-32.145l-110.687-16.083c-5.619-.82-10.474-4.347-12.986-9.435l-49.501-100.308c-8.015-16.235-24.244-26.32-42.352-26.32s-34.337 10.085-42.352 26.32c0 .001-49.501 100.307-49.501 100.307-2.512 5.09-7.367 8.617-12.977 9.435l-110.694 16.083c-17.928 2.606-32.537 14.923-38.124 32.137-5.603 17.225-1.024 35.779 11.947 48.416l80.098 78.084c4.063 3.959 5.917 9.662 4.96 15.249l-18.912 110.254c-3.056 17.85 4.143 35.548 18.788 46.186 14.648 10.643 33.708 12.022 49.744 3.599l99.002-52.052c5.022-2.639 11.019-2.638 16.036-.003l99.01 52.055c16.036 8.424 35.096 7.044 49.744-3.599 14.644-10.639 21.844-28.336 18.788-46.186l-18.913-110.249c-.957-5.592.896-11.295 4.962-15.257z" />
    </svg>
  );
}
